
import React, { useState } from "react";



const Sleep = () => {

    const [{age, age2}, setAge] = useState({age:20, age2:13});

    const handleClick = () => {
        setAge( currentAge => ({...currentAge, age: currentAge.age +1, age2: currentAge.age2 +1}))
        setAge(currentAge => {return { ...currentAge, age: currentAge.age + 1, age2: currentAge.age2 + 1 }})
    }

    return (
        <div>
            <button onClick={handleClick}>Make me older!!</button>
            <h1>I am {age} years old!</h1>
            <h1> but, My sister {age2} years old!</h1>
        </div>

    );
}

export default Sleep;